import { PriceStrategy, Shop } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { fetchContext } from '@/utils/http/fetchContext';
import { Thunk } from '@/redux/types';
import { ContextFetchAction, CoreActionTypes } from '../types';

type PriceStrategyParameters = { name: string; value: string }[];
type PriceStrategyWithParameters = { parameters: PriceStrategyParameters };

const hasParameters = (
  priceStrategy: PriceStrategy
): priceStrategy is PriceStrategy & PriceStrategyWithParameters => 'parameters' in priceStrategy;

const getValue = (parameters: PriceStrategyParameters, parameterName: string) =>
  parseFloat(assertDefined(parameters.find(({ name }) => name === parameterName)).value);

export const fetchContextAction = (): Thunk<Promise<Shop>, ContextFetchAction> => (dispatch) =>
  fetchContext().then((shop) => {
    const priceStrategy = shop.priceStrategy;
    if (hasParameters(priceStrategy)) {
      const parameters = priceStrategy.parameters;
      if (priceStrategy.type === 'TeamshirtPriceStrategy') {
        priceStrategy.settings = {
          firstPrintAreaCosts: getValue(parameters, 'firstPrintAreaCosts'),
          additionalPrintAreaCosts: getValue(parameters, 'additionalPrintAreaCosts'),
        };
      } else if (priceStrategy.type === 'FulfillmentPriceStrategy') {
        priceStrategy.settings = {
          printAreaPrice: getValue(parameters, 'printAreaPrice'),
        };
      }
    }

    dispatch({ type: CoreActionTypes.CONTEXT_FETCH, payload: shop });
    return shop;
  });
